import * as yup from "yup";

export const clientDetailsFormExcludingPricingPlan = yup.object({
  "client-name": yup
    .string()
    .required("Client name is required")
    .min(2, "Must be two characters or more")
    .trim(),
  "address-city": yup.string().min(2, "Must be two characters or more").trim(),
  "address-zip-code": yup
    .string()
    .min(2, "Must be two characters or more")
    .trim(),
  "country-select": yup
    .object({
      code: yup.string().required("Country name is required."),
      name: yup.string().required("Country code is required."),
    })
    .nullable()
    .required("Country is required"),
});
